import { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { getUserOrganisationsAction } from '../../../store/authSlice';
export const useHome = () => {
    // ========== REDUX SELECTORS ==========
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const orgLoading = useSelector((state) => state.auth.userOrganisations.loading);
    // ========== LOCAL STATE ==========
    const [loading, setLoading] = useState(false);
    // ========== HANDLERS ==========
    const handleLogin = useCallback(async (values) => {
        setLoading(true);
        try {
            const resultAction = await dispatch(getUserOrganisationsAction({
                email: values.email,
                password: values.password
            }));
            if (getUserOrganisationsAction.fulfilled.match(resultAction)) {
                message.success('Login successful!');
                navigate('/organisations', { replace: true });
            }
            else {
                message.error('Login failed. Please check your credentials.');
            }
        }
        catch (error) {
            console.error('Login error:', error);
            message.error('Login failed. Please check your credentials.');
        }
        finally {
            setLoading(false);
        }
    }, [dispatch, navigate]);
    return {
        // State
        loading: loading || orgLoading,
        // Handlers
        handleLogin,
    };
};
